import { useState } from 'react';
import { Download, Loader2 } from 'lucide-react';
import { downloadCsv } from '@/lib/downloadCsv';
import { errorMessage } from '@/lib/errorMessage';
import { toast } from '@/stores/toast';
import { cn } from '@/lib/cn';

interface ExportCsvButtonProps {
  /** Querystring de filtros de transações (sem o "?"). */
  qs: string;
  filename?: string;
  /** 'pill' = botão com rótulo; 'icon' = quadrado só com ícone. */
  variant?: 'pill' | 'icon';
  className?: string;
}

/** Botão de "Exportar CSV" — dispara o download autenticado e dá feedback via toast. */
export function ExportCsvButton({
  qs,
  filename = 'transacoes.csv',
  variant = 'pill',
  className,
}: ExportCsvButtonProps) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading) return;
    setLoading(true);
    try {
      await downloadCsv(qs, filename);
      toast('Exportação concluída.', 'success');
    } catch (err) {
      toast(errorMessage(err), 'error');
    } finally {
      setLoading(false);
    }
  };

  const Icon = loading ? Loader2 : Download;

  if (variant === 'icon') {
    return (
      <button
        type="button"
        onClick={() => void handleClick()}
        disabled={loading}
        aria-label="Exportar CSV"
        title="Exportar CSV"
        className={cn(
          'grid size-9 place-items-center rounded-full border border-border text-muted transition-colors hover:border-muted hover:text-ink disabled:opacity-60',
          className,
        )}
      >
        <Icon className={cn('size-4', loading && 'animate-spin')} />
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={() => void handleClick()}
      disabled={loading}
      className={cn(
        'flex h-9 items-center gap-2 rounded-full border border-border px-3 text-sm font-medium text-muted transition-colors hover:border-muted hover:text-ink disabled:opacity-60',
        className,
      )}
    >
      <Icon className={cn('size-4', loading && 'animate-spin')} />
      Exportar CSV
    </button>
  );
}
